var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs10: "", "offset-xs1": "" } },
        [
          _c(
            "v-stepper",
            {
              staticClass: "elevation-0",
              attrs: { value: _vm.editMode ? 2 : 1 },
            },
            [
              _c(
                "v-stepper-header",
                [
                  _c(
                    "v-stepper-step",
                    { attrs: { step: "1", complete: _vm.editMode } },
                    [_vm._v("Impostare totale progressi da applicare")]
                  ),
                  _c("v-divider"),
                  _c("v-stepper-step", { attrs: { step: "2" } }, [
                    _vm._v("Specificare progressi per singola lavorazione"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c("v-divider"),
          _c(
            "div",
            { staticClass: "progresso", staticStyle: { margin: "20px" } },
            [
              _c(
                "v-data-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.items,
                    "hide-default-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "tr",
                            { staticClass: "rigaProgresso" },
                            [
                              _c("td", { staticClass: "colId" }, [
                                _c("span", [_vm._v(_vm._s(item.desc))]),
                              ]),
                              item.tipoRiga == 0
                                ? _vm._l(item.values, function (value, index) {
                                    return _c(
                                      "td",
                                      {
                                        key: `tot_${item.desc}_${index}`,
                                        staticClass: "rigaProgTot",
                                      },
                                      [
                                        value.totale > 0
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(value.rimanenti) + " "
                                              ),
                                              _c(
                                                "i",
                                                {
                                                  staticStyle: {
                                                    color: "darkgray",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(value.fatti) +
                                                      "/" +
                                                      _vm._s(value.totale) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    )
                                  })
                                : _vm._e(),
                              item.tipoRiga == 2
                                ? _vm._l(item.values, function (value, index) {
                                    return _c(
                                      "td",
                                      {
                                        key: "edit_" + index,
                                        staticClass: "rigaProgItem",
                                      },
                                      [
                                        _vm.items[0].values[index].rimanenti > 0
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: item.values[index],
                                                  expression:
                                                    "item.values[index]",
                                                  modifiers: { number: true },
                                                },
                                              ],
                                              staticClass: "rigaProgInput",
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                max: _vm.items[0].values[index]
                                                  .rimanenti,
                                              },
                                              domProps: {
                                                value: item.values[index],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    item.values,
                                                    index,
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  })
                                : _vm._e(),
                              item.tipoRiga == 3
                                ? _vm._l(item.values, function (value, index) {
                                    return _c(
                                      "td",
                                      {
                                        key: "edit_lav_" + index,
                                        staticClass: "rigaProgItem",
                                      },
                                      [
                                        item.values[index].rimanenti > 0
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value:
                                                    item.values[index].fatti,
                                                  expression:
                                                    "item.values[index].fatti",
                                                  modifiers: { number: true },
                                                },
                                              ],
                                              staticClass: "rigaProgInput",
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                max: item.values[index]
                                                  .rimanenti,
                                              },
                                              domProps: {
                                                value: item.values[index].fatti,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    item.values[index],
                                                    "fatti",
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  })
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "no-data" },
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            value: true,
                            color: "error",
                            icon: "warning",
                          },
                        },
                        [_vm._v(" Sorry, nothing to display here :( ")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "darken-1", text: "" },
                  on: { click: _vm.annullaModificaProgressi },
                },
                [_vm._v(_vm._s(_vm.editMode ? "Indietro" : "Annulla"))]
              ),
              !_vm.editMode
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: { click: _vm.passaInModoEdit },
                    },
                    [_vm._v("Avanti")]
                  )
                : _vm._e(),
              _vm.editMode
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: { click: _vm.inviaModificaProgressi },
                    },
                    [_vm._v("Salva")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }